export const EDITOR_V3_OPEN_LINK_OPTIONS_EVENT = "editor-v3:open-link-options";
